import React from "react";
import Error from "../../../components/Error/index";
import Spinner from "../../../components/presentationals/Spinner";
import { capitalize } from "../../../utils/common";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    // margin: "10px",
    height: "20px",
    width: "20px",
    display: "flex",
    // justifyContent: "center",
    alignItems: "center",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
}));

function EarningsTabsView(props) {
  let {
    getSection,
    triggerFetchEarnings,
    triggerFetchEarningsCSV,
    earningsCSVObj,
    earningsObj,
    filterValue,
    data,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    csvEndPointUrl,
    sectionName,
    csv,
    key,
    earningsCsvFilter,
    earningsDispValue,
    getURL,
    url,
  } = props;

  return (
    <>
      {earningsObj &&
      earningsObj.loading &&
      earningsObj.loading[getSection(url)] ? (
        <Spinner />
      ) : earningsObj && earningsObj.data && earningsObj.data[url] ? (
        <div className="datatable table-responsive" data-cy="earnings-table">
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">Quantity</th>
                <th scope="col">Value</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {earningsObj &&
                earningsObj.data &&
                earningsObj.data[url] &&
                earningsObj.data[url].map((obj, index) => (
                  <tr key={index}>
                    <td scope="row">{capitalize(obj.name)}</td>
                    {obj.name !== "GRAND TOTAL" ? (
                      <td scope="row">
                        <font color="#ffa600">{obj.qty}</font>
                      </td>
                    ) : (
                      <td scope="row">{obj.qty}</td>
                    )}
                    {obj.name !== "GRAND TOTAL" ? (
                      //<link onClick={() => { csv(obj.name) }}>
                      <>
                        <td scope="row">
                          <font color="#FF00FF">{obj.val}</font>
                        </td>
                        <td scope="row">
                          {props.isCsvActive === "Y" ? (
                            <span className="text-start mr-5">
                              {earningsCSVObj &&
                              earningsCSVObj.loading &&
                              earningsCSVObj.loading[obj.name] ? (
                                <Spinner
                                  showAlert={false}
                                  useStyles={useStyles}
                                  width={"20px"}
                                />
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm m-0 p-0"
                                  onClick={() => {
                                    csv(obj.name);
                                  }}
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/icons/download-arrow.svg"
                                    }
                                    alt="download"
                                  />
                                </button>
                              )}
                            </span>
                          ) : null}
                        </td>
                      </>
                    ) : (
                      <>
                        <td scope="row">{obj.val}</td>
                        <td scope="row"></td>
                      </>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
        earningsObj &&
        earningsObj.error &&
        earningsObj.error[getSection(url)] && (
          <Error error={earningsObj.error[getSection(url)]} />
        )
      )}
    </>
  );
}

export default EarningsTabsView;
